import {FormEventHandler} from "react";

import {isAndroid, isIOS} from "react-device-detect";

export const allowOnlyNumber: FormEventHandler<HTMLInputElement> = (event) => {
    event.currentTarget.value = event.currentTarget.value.replace(/[^0-9]/g, '');
}

export const allowOnlyNumberAndHyphen: FormEventHandler<HTMLInputElement> = (event) => {
    event.currentTarget.value = event.currentTarget.value.replace(/[^0-9-]/g, '');
}

export const sendApp = (command: string, parameter?: any) => {
    const data = JSON.stringify({command, parameter})
    try {
        if (isIOS) window.webkit.messageHandlers.callbackHandler.postMessage(data);
        if (isAndroid) window.Kwallet.callbackHandler(data);
    } catch (e) {
        console.error(e);
    }
}